export const normalizeApprovalListCursor = (value: unknown): string => {
  if (value == null) return ''
  const s = String(value).trim()
  if (s === '' || s.toLowerCase() === 'nil' || s.toLowerCase() === 'null') return ''
  return s
}

export const normalizeApprovalListPaginationCursors = (
  pagination: { prev_cursor?: unknown; next_cursor?: unknown } | null | undefined,
): { prev_cursor: string; next_cursor: string } => ({
  prev_cursor: normalizeApprovalListCursor(pagination?.prev_cursor),
  next_cursor: normalizeApprovalListCursor(pagination?.next_cursor),
})
